









































import { Component, Vue } from "vue-property-decorator";
import { IValidateField, validateForm } from "@/services/validateForm.ts";

@Component({})
export default class Form extends Vue {
  formFieldArr: IValidateField[] = [
    { name: "email", value: "", rules: "email|min:7" }
  ];
  isValidateErr: boolean = false;
  isSend: boolean = false;

  handleSend(e) {
    this.isSend = true;
    e.target.blur();
    if (this.handleValidate()) {
      this.isSend = false;
      this.$refs.email["value"] = "";
      this.$refs.email["blur"]();
      this.$store.dispatch("app/togglePopupAction", { name: "success" });
    }
  }
  handleValidate() {
    if (!this.isSend) {
      return;
    }
    const emailVal: any = this.$refs.email;
    this.formFieldArr[0].value = emailVal.value;
    const isValid = new validateForm(this.formFieldArr).isValid();
    this.isValidateErr = !isValid;
    return isValid;
  }
}
